import Animation from '../../animations/entering-animation'
import StyleTweeners from '../style-tweeners'

/*
 * Animation we play when a new stacked area serie is added
 */
class ExitingStackedAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }


  match (serie) {
    if (!this.previous.scalers.x || !this.exitingSeries.size()) {
      // We didn't gain a serie or not an update, don't use
      return false
    }

    return this.exitingSeries.filter(serie => serie.stackBy).size()
  }

  animate (serie, entering, selection, merged, exiting) {
    if (exiting.size()) {
      let stack = this.previous.series.filter(serie => serie.stackBy)
        , stackData = stack.data().reverse() // Reverse to match the order they appear in the DOM
        , exitingSerie = exiting.selection().datum()
        , idx = exitingSerie.points[0]._index
        , scalers = {
            x: this.previous.scalers.x.center,
            y: (raw, d) => {
              if (idx === 0) {
                // Was at the bottom, send it to 0
                return this.yScale(0)
              } else {
                // Add the new path elements at the old location

                // Grab the old point based on rangeId
                let point = stackData[idx - 1].points.find(p => p.rangeId === d.rangeId)
                return this.yScale(point._range[1])
              }
            }
          }

      // Move the exiting paths
      this.pathAdjuster.transitionPathTo(exitingSerie.points, exiting, scalers.x, scalers.y)

      // Fade out the fill
      exiting.tween('fade-out', this.styleTweeners.fadeOut(merged, true, 1))
    } else {
      this._updateDrawing(merged) // basic update
    }
  }
}

export default ExitingStackedAnimation
